import { Injectable, NgZone, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
// store
import { Subject } from 'rxjs';
// google maps
// import { MapsAPILoader } from '@agm/core';
import { google } from "google-maps";
// globals
import { ADDRESSY_API_KEY } from '../../shared/globals';


@Injectable({
  providedIn: 'root',
})
export class GeocodeService {

  private _geocoder;

  public geocodeSubject$: Subject<any> = new Subject();
  public placeIdGeoSubject$: Subject<any> = new Subject();
  public geoCodeValue: any = { latitude: '', longitude: '' };
  public boundries
  public setParams;
  constructor (
    private http:HttpClient,
    // private _mapsAPILoader: MapsAPILoader,
     private _ngZone: NgZone,
     @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      // this._mapsAPILoader.load().then(() => {
      //   this._geocoder = new google.maps.Geocoder();
      //   const sw = new google.maps.LatLng(48, 9)
      //   const ne = new google.maps.LatLng(46, 5)
      //   this.boundries = new google.maps.LatLngBounds(sw,ne)

      // }).catch(() => {
      //   console.log('geo error');
      // });
    }
  }
/*
  getGeocode(postcode: any, countryCode:any) {

    const result: any = [];

    if (typeof postcode === 'undefined') {
      this.geocodeSubject$.next('postcode error');
      return;
    }
    this.setParams = countryCode === 'CH' ?
    { 'address': postcode, 'region': countryCode, 'bounds': this.boundries }
    : { 'address': postcode, 'region': countryCode };
    console.log('boundries', this.boundries, countryCode)
    this._geocoder.geocode({ 'address': postcode, 'region': countryCode, 'componentRestrictions': { 'country': countryCode} }, (results, status) => {

      this._ngZone.run(() => {

        if (status === 'ZERO_RESULTS') {
          this.geocodeSubject$.next('no results');
          return;
        }

        const latitude = results[0].geometry.location.lat();
        const longitude = results[0].geometry.location.lng();

        this.geoCodeValue.latitude = latitude;
        this.geoCodeValue.longitude = longitude;

        this.geocodeSubject$.next(this.geoCodeValue);

        return;

      });

    });

  };

  */

  getGeocode(postcode:any, country:any) {
    const result:any = [];
    if (typeof postcode === 'undefined') {
      this.geocodeSubject$.next('postcode error');
      return
    }
    const url = 'https://api.addressy.com/Geocoding/International/Geocode/v1.10/json3.ws?';

    let params = new HttpParams();
    params = params.append('Key', ADDRESSY_API_KEY);
    params = params.append('country', country);
    params = params.append('location', postcode);

    this.http.get<any>(url, {params: params})
    .subscribe(res => {

      if (res.Items.length === 0) {
        this.geocodeSubject$.next('no results');
        return;
      }

      const latitude = res.Items[0].Latitude;
      const longitude = res.Items[0].Longitude;

      this.geoCodeValue.latitude = latitude;
      this.geoCodeValue.longitude = longitude;

      this.geocodeSubject$.next(this.geoCodeValue);

      return;
    });

  }

  getPlaceId(postcode: any) {

    const result: any = [];

    if (typeof postcode === 'undefined') {
      this.placeIdGeoSubject$.next('postcode error');
      return;
    }

    this._geocoder.geocode({ 'address': postcode }, (results, status) => {

      this._ngZone.run(() => {

        const thisId = results[0].place_id;
        this.placeIdGeoSubject$.next(thisId);

      });

    });

  }

};
